import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { TablePage, TableColumnProps } from "components/alove/TablePage";
import { GeneralCode, GeneralCodeType } from "models/content/GeneralCode";
import { GridEventListener, GridGroupingColDefOverride } from "@mui/x-data-grid-pro";

import { T } from "components/alove/Translator";
import { useState, useMemo } from "react";
import {AddGeneralCodeDialog} from "components/alove/AddGeneralCodeDialog";
import { ActionsRowProps, } from "components/alove/ActionsRow";
import { getGeneralCodes, updateGeneralCodeDO, updateGeneralCodesOrdinals } from "utils/generalCodesUtils";
import { addAlert, useMaterialUIController } from "context";
import { TwoSizeChip } from "components/alove/Chips";
import { camelCaseToCapitalizedWords } from "utils/globalsUtils";

const generalCodeTypesArray = Object.values(GeneralCodeType);
const GeneralCodesTable = () => {
  
  const [refresh, setRefresh] = useState(0);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [rows, setRows] = useState<GeneralCode[]>([]);
  const groupingColDef: GridGroupingColDefOverride = { width: 500 };

  const columns: TableColumnProps<GeneralCode>[] = [
    { field: "id", headerName: "Id", flex: 0.5, minWidth: 50, editableCB: () => false },
    { field: "name", headerName: "Name", flex: 1, minWidth: 150, editableCB: () => true },
    { field: "isActive", headerName: "Is Active", type: "boolean", editable: true },
    
  ];

  const loadNext = async<T extends GeneralCodeType | GeneralCodeType[]>(
    filters: any,
    page: number
  ): Promise<GeneralCode[]> => {
    const res = await getGeneralCodes(filters.type);
    setRows(res);
    return res;
  };

  const actions: ActionsRowProps = {
    addActions: [
      {
        label: "Add General Code",
        onClick: () => setOpenAddDialog(true),
        color: "primary",
      },
    ],
  };

  const filters = [
    {
      label: "type",
      multiple: false,
      options: generalCodeTypesArray.map((t) => ({
        key: t,
        label: camelCaseToCapitalizedWords(t),
      }))
    }
  ];

  const [, dispatch] = useMaterialUIController();
  const processRowUpdate = async (newRow: GeneralCode, oldRow: GeneralCode) => {
    if (newRow.name != oldRow.name || newRow.isActive != oldRow.isActive) {
      await updateGeneralCodeDO(newRow.id, newRow.name, newRow.isActive);
    }

    return newRow;
  };

  const onRowOrderChange: GridEventListener<"rowOrderChange"> = async (params) => {
    try {
      ;
      
      // Get the current data from the table
      // We need to update the ordinals based on the new order
      // First, let's create a copy of the rows array
      const updatedRows = [...rows];
      
      // Move the row from oldIndex to targetIndex
      const [movedRow] = updatedRows.splice(params.oldIndex, 1);
      updatedRows.splice(params.targetIndex, 0, movedRow);
      
      // Update the ordinals based on the new order
      const updatedCodes = updatedRows.map((code, index) => ({
        id: code.id,
        ordinal: index + 1
      }));
      
      // Save the updated ordinals to the database
      await updateGeneralCodesOrdinals(updatedCodes);
      
      // Update the local state
      setRows(updatedRows);
      
      // Show success message
      addAlert(dispatch, "Order updated successfully");
    } catch (error) {
      console.error("Error updating order:", error);
      addAlert(dispatch, "Failed to update order", true);
    }
  }

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle="General Codes" />


        <TablePage
          title="General Codes"
          table={{
            columns,
            loadNext,
            pagination: true,
            groupingColDef,
            processRowUpdate,
            getRowId: (row) => `${row.id}`,
            onRowOrderChange
          }}
          actions={actions}
          filters={filters}
          refresh={refresh}
          
        />

        {/* <AddGeneralCodeDialog
          open={openAddDialog}
          onClose={() => setOpenAddDialog(false)}
          onSave={() => {
            setOpenAddDialog(false);
            setRefresh((p) => p + 1);
          }}
        /> */}
    </DashboardLayout>
  );
};
export default GeneralCodesTable;